import type { TourDefinition } from '../types'

export const notificationsTour: TourDefinition = {
  id: 'notifications',
  title: 'Notifications Tour',
  description: 'Configure routing rules, channels, and alert thresholds for your team.',
  icon: 'Bell',
  route: '/tenant/notifications',
  estimatedMinutes: 2,
  steps: [
    {
      element: '[data-tour-id="notifications-feed"]',
      popover: {
        title: 'Notification Feed',
        description: 'All system events, workflow alerts, and BYOK engine status changes appear here in chronological order.',
      },
      aiContext: 'What types of events generate notifications in Vharta?',
    },
    {
      element: '[data-tour-id="notification-channels-link"]',
      popover: {
        title: 'Notification Channels',
        description: 'Connect Slack, PagerDuty, email, or webhooks to route alerts to the right people.',
      },
      aiContext: 'How do I connect Slack to receive Vharta workflow failure alerts?',
    },
    {
      element: '[data-tour-id="routing-rules-link"]',
      popover: {
        title: 'Routing Rules',
        description: 'Define rules to route specific alert types to specific channels or team members.',
      },
      aiContext: 'How do I create a routing rule that sends Dagster failures to PagerDuty?',
    },
  ],
}
